import React from "react";

export function Worldle() {
  return (
    <span className="font-bold">
      <span className="text-green-600">WARD</span>LE
    </span>
  );
}
